const formula = [
  {
    id: 'common',
    value: 'common',
    label: '常用函数',
    children: [
      {
        id: 'sum',
        value: 'SUM(param)',
        label: 'SUM',
        tip: '求和',
        example: 'SUM(3) 返回3 (聚合函数只能允许一个参数)',
        abbreviation: '求和'
      }, {
        id: 'max',
        value: 'MAX(param)',
        label: 'MAX',
        tip: '求最大值',
        example: 'MAX(3) 返回3 (聚合函数只能允许一个参数)',
        abbreviation: '最大值'
      }, {
        id: 'concat',
        value: 'CONCAT(param,param)',
        label: 'CONCAT',
        tip: '将字符串或公式进行拼接处理, 字符串使用单双引号包裹.报表模块使用时可以不使用引号包裹',
        example: 'CONCAT("a", 1+2, "b") 返回 a3b',
        abbreviation: '拼接'
      }, {
        id: 'if',
        value: 'IF(param,param,param)',
        label: 'IF',
        tip: '第一个参数为条件, 后面两个参数为数值, 条件满足返回第二个参数, 不满足返回第三个参数',
        example: '示例 IF (1>2, 3, 4) 返回 4. ',
        abbreviation: '如果'
      }, {
        id: 'round',
        value: 'ROUND(param,param) ',
        label: 'ROUND',
        tip: '该数值是按照指定的小数位数进行四舍五入运算的结果',
        example: 'ROUND(3.1415926, 2) 返回 3.14  ROUND(193, -2) 返回 200',
        abbreviation: '四舍五入'
      }, {
        id: 'today',
        value: 'TODAY()',
        label: 'TODAY',
        tip: '获取当前日期',
        example: 'TODAY() 返回 2018-08-27',
        abbreviation: '当前日期'
      }, {
        id: 'and',
        value: 'AND(param)',
        label: 'AND',
        tip: '并且',
        example: 'true and false  返回 false',
        abbreviation: '并且'
      }, {
        id: 'or',
        value: 'OR(param)',
        label: 'OR',
        tip: '或者',
        example: 'true or false  返回 true',
        abbreviation: '或者'
      } ]
  },
  {
    id: 'math',
    value: 'math',
    label: '数学函数',
    children: [{
      id: 'abs',
      value: 'ABS(param)',
      label: 'ABS',
      tip: '获取绝对值',
      example: 'ABS(-1.2) 返回 1.2',
      abbreviation: '绝对值'
    }, {
      id: 'round',
      value: 'ROUND(param,param) ',
      label: 'ROUND',
      tip: '该数值是按照指定的小数位数进行四舍五入运算的结果',
      example: 'ROUND(3.1415926, 2) 返回 3.14  ROUND(193, -2) 返回 200',
      abbreviation: '四舍五入'
    }, {
      id: 'int',
      value: 'INT(param)',
      label: 'INT',
      tip: '将数字向下舍入到最接近的整数',
      example: 'INT(2.25),返回2',
      abbreviation: '取整'
    }, {
      id: 'mod',
      value: 'MOD(param,param)',
      label: 'MOD',
      tip: '返回两数相除的余数,结果的符号与除数相同',
      example: 'MOD(3, 2) 等于 1,MOD(-3, 2) 等于1,MOD(3, -2) 等于-1',
      abbreviation: '余数'
    }, {
      id: 'quotient',
      value: 'QUOTIENT(param, param)',
      label: 'QUOTIENT',
      tip: '返回除法的整数部分。要放弃除法的余数时，可使用此函数',
      example: 'QUOTIENT(5,2)返回 2',
      abbreviation: '商数取整'
    }, {
      id: 'rounddown',
      value: 'ROUNDDOWN(param, param)',
      label: 'ROUNDDOWN',
      tip: '向下(绝对值减小的方向)舍入数字',
      example: 'ROUNDDOWN(3.2, 0)将 3.2 向下舍入，小数位为 0 (3),ROUNDDOWN(3.14159, 3)将 3.14159 向下舍入，保留三位小数 (3.141)',
      abbreviation: '向下舍入'
    }, {
      id: 'roundup',
      value: 'ROUNDUP(param)',
      label: 'ROUNDUP',
      tip: '向上(绝对值增大的方向)舍入数字',
      example: 'ROUNDUP(3.2)将 3.2 向上舍入， (4),ROUNDUP(3.14159)将 3.14159 向上舍入 (4)',
      abbreviation: '向上舍入'
    }, {
      id: 'trunc',
      value: 'TRUNC(param, param)',
      label: 'TRUNC',
      tip: '将数字的小数部分截去，返回整数',
      example: 'TRUNC（89.985，2）=89.98,TRUNC（89.985,0）=89 (即取整),TRUNC（89.985，"-1"）=80',
      abbreviation: '截取'
    }, {
      id: 'rand',
      value: 'RAND()',
      label: 'RAND',
      tip: '返回大于等于 0 且小于 1 的均匀分布随机实数',
      example: '无',
      abbreviation: '随机数'
    }, {
      id: 'randbetween',
      value: 'RANDBETWEEN(param, param)',
      label: 'RANDBETWEEN',
      tip: '返回位于两个指定数之间的一个随机整数',
      example: 'RANDBETWEEN(9,100)',
      abbreviation: '区间随机数'
    }, {
      id: 'RmbConvert',
      value: 'RMBCONVERT(param)',
      label: 'RMBCONVERT',
      tip: '参数为数字金额,返回大写的人民币数值',
      example: '0.75 返回 人民币柒角伍分',
      abbreviation: '大写数字'
    }, {
      id: 'gcd',
      value: 'GCD(param,param)',
      label: 'GCD',
      tip: '一组整数的最大公约数',
      example: 'gcd(3,6,12) -> 3',
      abbreviation: '最大公约数'
    }]
  },
  {
    id: 'concat',
    value: 'concat',
    label: '聚合函数',
    children: [
      {
        id: 'count',
        value: 'COUNT(param)',
        label: 'COUNT',
        tip: '求个数',
        example: 'COUNT(1) 返回 1 (聚合函数只能允许一个参数)',
        abbreviation: '计数'
      }, {
        id: 'distinct',
        value: '(DISTINCT)',
        label: 'DISTINCT',
        tip: '去重',
        example: 'DISTINCT无法单独使用，仅能和聚合函数一起使用，如COUNT((DISTINCT) a),其中a表示一列数据，如果该列数据共有六条数据：1,1,2,2,2,3 则返回 3',
        abbreviation: '去重'
      }, {
        id: 'max',
        value: 'MAX(param)',
        label: 'MAX',
        tip: '求最大值',
        example: 'MAX(3) 返回3 (聚合函数只能允许一个参数)',
        abbreviation: '最大'
      }, {
        id: 'sum',
        value: 'SUM(param)',
        label: 'SUM',
        tip: '求和',
        example: 'SUM(3) 返回3 (聚合函数只能允许一个参数)',
        abbreviation: '求和'
      }, {
        id: 'group_concat',
        value: 'GROUP_CONCAT(param)',
        label: 'GROUP_CONCAT',
        tip: '分组拼接',
        example: 'GROUP_CONCAT([1, 2, 3]) 返回"1, 2, 3" (聚合函数只能允许一个参数)',
        abbreviation: '分组拼接'
      }, {
        id: 'average',
        value: 'AVERAGE(param)',
        label: 'AVERAGE',
        tip: '求平均值',
        example: 'AVERAGE(1) 返回 1 (聚合函数只能允许一个参数)',
        abbreviation: '平均值'
      }, {
        id: 'sumif',
        value: 'SUMIF(param, param, param)',
        label: 'SUMIF',
        tip: '条件求和',
        example: 'SUMIF(1,2,3,4, \'>2\') 返回 7, 注意, SUMIF 函数中的最后一个参数只能使用比较条件(>、<、=、>=、<=、!=)，最后一个参数目前仅支持手动输入常量, 不能使用变量',
        abbreviation: '条件求和'
      },
      {
        id: 'averageif',
        value: 'AVERAGEIF(param, param, param)',
        label: 'AVERAGEIF',
        tip: '条件求平均数',
        example: 'AVERAGEIF(1,2,3,4, \'>2\') 返回 3.5, 注意, AVERAGEIF 函数中的最后一个参数只能使用比较条件(>、<、=、>=、<=、!=)，最后一个参数目前仅支持手动输入常量, 不能使用变量',
        abbreviation: '条件平均值'
      }, {
        id: 'simple',
        value: 'MIN(param) ',
        label: 'MIN',
        tip: '求最小值',
        example: 'MIN(3) 返回3 (聚合函数只能允许一个参数)',
        abbreviation: '最小'
      }, {
        id: 'large',
        value: 'LARGE(param,param)',
        label: 'LARGE',
        tip: '返回数据集中第 k 个最大值',
        example: 'LARGE(1,2,3,4,5,6,7,8,9,\'3\')第三个最大值为7',
        abbreviation: '第k个最大值'
      }, {
        id: 'small',
        value: 'SMALL(param,param)',
        label: 'SMALL',
        tip: '返回数据集中第 k 个最小值',
        example: 'SMALL(1,2,3,4,5,6,7,8,9,\'3\')第三个最小值为3',
        abbreviation: '第k个最小值'
      }, {
        id: 'median',
        value: 'MEDIAN(param,param)',
        label: 'MEDIAN',
        tip: '返回一组已知数字的中值',
        example: 'MEDIAN(3,21,66,100,29) 返回29',
        abbreviation: '中值'
      }]
  },
  {
    id: 'text',
    value: 'text',
    label: '字符串函数',
    children: [{
      id: 'left',
      value: 'LEFT(param,param)',
      label: 'LEFT',
      tip: '从文本字符串的第一个字符开始返回指定个数的字符',
      example: 'LEFT("abcdefg", 3) 返回 abc',
      abbreviation: '取左'
    }, {
      id: 'right',
      value: 'RIGHT(param,param)',
      label: 'RIGHT',
      tip: '从内容字符串的最后一个字符开始返回指定长度的字符',
      example: 'RIGHT("abcdefg", 3) 返回 efg',
      abbreviation: '取右'
    }, {
      id: 'replace',
      value: 'REPLACE(param,param,param)',
      label: 'REPLACE',
      tip: '将指定的 param1 字符串中的 param2 字符替换成 param3',
      example: 'REPLACE("abcdefg", "efg", "123") 返回 abcd123',
      abbreviation: '替换'
    }, {
      id: 'concat',
      value: 'CONCAT(param,param)',
      label: 'CONCAT',
      tip: '将字符串或公式进行拼接处理, 字符串使用单双引号包裹.报表模块使用时可以不使用引号包裹',
      example: 'CONCAT("a", 1+2, "b") 返回 a3b',
      abbreviation: '拼接'
    }, {
      id: 'contains',
      value: 'CONTAINS(param,param)',
      label: 'CONTAINS',
      tip: '判断param1中是否包含param2,若包含返回true,不包含返回false',
      example: '',
      abbreviation: '包含'
    }, {
      id: 'NotContains',
      value: 'NOTCONTAINS(param,param)',
      label: 'NOTCONTAINS',
      tip: '判断param1中是否包含param2,若不包含返回true,包含返回false',
      example: '',
      abbreviation: '不包含'
    }, {
      id: 'len',
      value: 'LEN(param)',
      label: 'LEN',
      tip: '获取字符串中的个数',
      example: 'len("sfsdf") 返回5',
      abbreviation: '获取字符串个数'
    }, {
      id: 'lower',
      value: 'LOWER(param)',
      label: 'LOWER',
      tip: '字母转小写',
      example: 'lower("ABC") 返回abc',
      abbreviation: '字母转小写'
    }, {
      id: 'upper',
      value: 'UPPER(param)',
      label: 'UPPER',
      tip: '字母转大写',
      example: 'upper("abc") 返回ABC',
      abbreviation: '字母转大写'
    }, {
      id: 'trim',
      value: 'TRIM(param)',
      label: 'TRIM',
      tip: '去除字符串的头尾空格',
      example: 'trim(" ab c ") 返回ab c',
      abbreviation: '去除字符串的头尾空格'
    }, {
      id: 'IfNull',
      value: 'IFNULL(param,param)',
      label: 'IFNULL',
      tip: '判断param1是否为空, 是则返回param2',
      example: "IFNULL('', true) 返回 true",
      abbreviation: '判空'
    }]
  },
  {
    id: 'date',
    value: 'date',
    label: '日期函数',
    children: [{
      id: 'now',
      value: 'NOW()',
      label: 'NOW',
      tip: '获取当前时间',
      example: 'NOW() 返回 2018-08-27 17:03:23',
      abbreviation: '当前时间'
    }, {
      id: 'edatetime',
      value: 'EDateTime(param, param, param)',
      label: 'EDateTime',
      tip: '加减指定时间间隔，得到一个新的日期时间,第一个参数date是日期或者日期时间,第二个参数 type的类型有y、M、d、H、m、s,第三个参数nums支持正数和负数,不支持小数',
      example: 'EDateTime("2018-04-18", "m", "1") 返回是 2018-04-18 00:01:00',
      abbreviation: '加减时间间隔'
    }, {
      id: 'fomon',
      value: 'FOMON()',
      label: 'FOMON',
      tip: '获取当月份的第一天',
      example: 'FOMON("2020-03-05") 返回 2020-03-01',
      abbreviation: '当月首日'
    }, {
      id: 'foyear',
      value: 'FOYEAR()',
      label: 'FOYEAR',
      tip: '获取当前年的第一天',
      example: 'FOYEAR("2020-05-20") 返回 2020-01-01',
      abbreviation: '当年首日'
    }, {
      id: 'today',
      value: 'TODAY()',
      label: 'TODAY',
      tip: '获取当前日期',
      example: 'TODAY() 返回 2018-08-27',
      abbreviation: '当前日期'
    }, {
      id: 'days',
      value: 'DAYS(param,param)',
      label: 'DAYS',
      tip: '获取两个日期的天数差',
      example: 'DAYS("2018-08-27", "2018-09-22") 返回 26, DAYS("2018-09-22", "2018-08-27") 返回 -26',
      abbreviation: '天数差'
    }, {
      id: 'seconds',
      value: 'SECONDS(param,param)',
      label: 'SECONDS',
      tip: '获取两个日期或时间的秒数差',
      example: 'SECONDS("2019-01-15 14:20:54", "2019-01-15 14:20:53") 返回 1, 注意, 如果使用一个日期和时间进行计算, 时间会从 1970-01-01 开始计时, 日期会从当天的 00:00:00 开始计算, 计算结果可能会超出预期之外',
      abbreviation: '秒数差'
    }, {
      id: 'eomonth',
      value: 'EOMONTH(param)',
      label: 'EOMONTH',
      tip: '获取指定月份 startDate 的最后一天',
      example: 'EOMONTH("1970-01-01") 返回 "1970-01-31"',
      abbreviation: '该月尾日'
    }, {
      id: 'isoweeknum',
      value: 'ISOWEEKNUM(param)',
      label: 'ISOWEEKNUM',
      tip: '获取指定日期 date 在全年的周数.',
      example: 'ISOWEEKNUM("1970-01-01") 返回 1',
      abbreviation: '年内第几周'
    }, {
      id: 'networkdays',
      value: 'NETWORKDAYS(param,param)',
      label: 'NETWORKDAYS',
      tip: '获取两个日期 startDate, endDate 之间的工作日天数',
      example: 'NETWORKDAYS("2018-09-03", "2018-09-10") 返回 6, NETWORKDAYS("2018-09-03", "2018-09-10", "2018-09-04", "2018-09-05") 返回 4',
      abbreviation: '区间工作日数'
    }, {
      id: 'weekday',
      value: 'WEEKDAY(param)',
      label: 'WEEKDAY',
      tip: '指定日期 date 是一周的第几天',
      example: 'WEEKDAY("2018-08-30") 返回 5. 周日是1,2018-08-30是周四,返回 5',
      abbreviation: '周内第几天'
    }, {
      id: 'workday',
      value: 'WORKDAY(param,param)',
      label: 'WORKDAY',
      tip: '获取指定日期 date 之后的若干个工作日 num 的日期',
      example: ' WORKDAY("2018-08-30", 5) 返回 "2018-09-06" WORKDAY("2018-08-30", 5, "2018-09-03") 返回 "2018-09-07"',
      abbreviation: '几个工作日后的日期'
    }, {
      id: 'eomonthex',
      value: 'EOMONTHEX(param, param)',
      label: 'EOMONTHEX',
      tip: '获取指定日期前或后或当前月份的最后一天,start_date是指定日期,months可正可负,0代表当月',
      example: 'EOMONTHEX("2019-1-3", "3")返回2019-4-30;EOMONTHEX("2019-1-3", "0")返回2019-1-31;EOMONTHEX("2019-1-3", "-1")返回2018-12-31;',
      abbreviation: '指定月尾日'
    }, {
      id: 'month',
      value: 'MONTH(param)',
      label: 'MONTH',
      tip: '获取指定日期的月份',
      example: 'month（2019-07-01）返回 7;',
      abbreviation: '指定月份'
    },
    {
      id: 'hour',
      value: 'HOUR(param)',
      label: 'HOUR',
      tip: '获取指定时间的小时数.当不传参时返回当前时间的小时数',
      example: 'hour("2020-07-15") 返回 "0"  hour(09:08:18）返回 9;',
      abbreviation: '小时值'
    },
    {
      id: 'minute',
      value: 'MINUTE(param)',
      label: 'MINUTE',
      tip: '获取指定时间的分钟数.当不传参时返回当前时间的分钟数',
      example: 'minute("2020-07-15") 返回 "0". minute(09:08:18）返回 8;',
      abbreviation: '分钟值'
    },
    {
      id: 'second',
      value: 'SECOND(param)',
      label: 'SECOND',
      tip: ' 获取指定时间的秒数.当不传参时返回当前时间的秒数',
      example: 'Second("2020-07-15") 返回 "0" second(09:08:18）返回 18;',
      abbreviation: '秒值'
    }
    ]
  },
  {
    id: 'logic',
    value: 'logic',
    label: '逻辑函数',
    children: [{
      id: 'IF',
      value: 'IF(param,param,param)',
      label: 'IF',
      tip: '第一个参数为条件, 后面两个参数为数值, 条件满足返回第二个参数, 不满足返回第三个参数',
      example: '示例 IF (1>2, 3, 4) 返回 4. ',
      abbreviation: '如果'
    }, {
      id: 'NOT',
      value: 'NOT(param)',
      label: 'NOT',
      tip: '查询获取参数相反的结果',
      example: 'NOT(true) 返回 false; NOT(1>2) 返回 true.',
      abbreviation: '非'
    }, {
      id: 'IsNull',
      value: 'ISNULL(param)',
      label: 'ISNULL',
      tip: '判断字符串是否为空',
      example: "ISNULL('') 返回 true",
      abbreviation: '空'
    }, {
      id: 'IsNotNull',
      value: 'ISNOTNULL(param)',
      label: 'ISNOTNULL',
      tip: '判断字符串是否为空',
      example: "ISNOTNULL('') 返回 false",
      abbreviation: '非空'
    }, {
      id: 'SWITCH',
      value: 'SWITCH(param, param, param, param, param)',
      label: 'SWITCH',
      tip: '多条件判断函数, 返回第一个成立的条件所对应的结果, 所有条件都不满足时返回默认值。默认值非必填, 不填默认是空字符串',
      example: "SWITCH(1 < 0, '结果1', 1 > 0, '结果2', '默认值') 返回 结果2",
      abbreviation: '多条件判断函数'
    }]
  },
  {
    id: 'system',
    value: 'system',
    label: '系统函数',
    children: [{
      id: 'user.name',
      value: 'USER.NAME()',
      label: 'USER.NAME',
      tip: '获取当前登录人姓名',
      example: '',
      abbreviation: '登录人姓名'
    }, {
      id: 'user.id',
      value: 'USER.ID()',
      label: 'USER.ID',
      tip: '获取当前登录人ID',
      example: '',
      abbreviation: '登录人ID'
    },
    {
      id: 'user.dept',
      value: 'USER.DEPT()',
      label: 'USER.DEPT',
      tip: '获取当前登录的部门名称',
      example: '',
      abbreviation: '登录人部门'
    },
    {
      id: 'user.deptid',
      value: 'USER.DEPTID()',
      label: 'USER.DEPTID',
      tip: '获取当前登录的部门ID',
      example: '',
      abbreviation: '登录人部门ID'
    },
    {
      id: 'user.post',
      value: 'USER.POST()',
      label: 'USER.POST',
      tip: '获取当前登录人的岗位名称',
      example: '',
      abbreviation: '登录人岗位名称'
    },
    {
      id: 'user.postid',
      value: 'USER.POSTID()',
      label: 'USER.POSTID',
      tip: '获取当前登录人的岗位ID',
      example: '',
      abbreviation: '登录人岗位ID'
    },
    {
      id: 'lately',
      value: 'LATELY(param)',
      label: 'LATELY',
      tip: '获取最近 param 天的参数, 函数内部输入具体的数字, 例如查询最近三十天的数据, lately(30).',
      example: '',
      abbreviation: '最近几天的'
    },
    {
      id: 'currentday',
      value: 'CURRENTDAY()',
      label: 'CURRENTDAY',
      tip: '当天函数',
      example: '',
      abbreviation: '当天'
    },
    {
      id: 'currentmon',
      value: 'CURRENTMON()',
      label: 'CURRENTMON',
      tip: '当月函数',
      example: '',
      abbreviation: '当月'
    },
    {
      id: 'currentyear',
      value: 'CURRENTYEAR()',
      label: 'CURRENTYEAR',
      tip: '当年函数',
      example: '',
      abbreviation: '当年'
    },
    {
      id: 'user.jobnum',
      value: 'USER.JOBNUM()',
      label: 'USER.JOBNUM',
      tip: '获取当前登录人的工号',
      example: '',
      abbreviation: '登录人工号'
    },
    {
      id: 'countif',
      value: 'COUNTIF(param,param)',
      label: 'COUNTIF',
      tip: "计算满足条件的个数countIf(`某一列`,'>2')",
      example: "countIf(1,2,3,4,5,'>2') --> 3",
      abbreviation: '计算满足条件的个数'
    }
    ]
  }
]

function getFormula (componentType) {
  return formula
}
function enableFormula (calculationType) {
  // javaEnableFormula 表单应该禁用的函数
  let javaEnableFormula = ['lately']
  let sqlEnableFormula = []
  let EnableFormula = []
  formula.forEach(el => {
    if (calculationType === 'java') {
      EnableFormula = javaEnableFormula
    } else {
      EnableFormula = sqlEnableFormula
    }
    el.children && el.children.forEach(el => {
      el.disabled = EnableFormula.includes(el.id)
    })
  })
}

// todo:未实现的函数
// SUBSTITUTE/SMALL/RandEq

export {getFormula, enableFormula}



// WEBPACK FOOTER //
// ./src/globalComponent/calculation/formula.js